import React from 'react';
import {useSelector} from 'react-redux';

import {Store} from 'src/types/store';
import {classYears} from 'shared/portfolio/utils';
import {CURRENT_SCHOOL_YEAR} from 'shared/utils';

import Section from 'shared/portfolio/components/section';
import styles from './upcoming-school-years.module.scss';

const UpcomingSchoolYears = () => {
  const graduationYear = useSelector((state: Store) => state.student.highSchoolInfo.graduationYear);
  const fourSchoolYears = classYears(graduationYear);
  const futureSchoolYears = Object.keys(fourSchoolYears)
    .filter((year) => parseInt(year.split('-')[1]) > CURRENT_SCHOOL_YEAR)
    .reverse();

  if (!futureSchoolYears.length) return null;

  return (
    <Section>
      <span className={styles.container}>
        <div className={styles.title}>{`${fourSchoolYears[futureSchoolYears[0]]} ${
          futureSchoolYears.length > 1
            ? `- ${fourSchoolYears[futureSchoolYears.at(-1)]} Years`
            : 'Year'
        }`}</div>
        {futureSchoolYears.length > 1
          ? 'Upcoming school years will become available for entry every July.'
          : 'Next school year will become available for entry in July.'}
      </span>
    </Section>
  );
};

export default UpcomingSchoolYears;
